angular.module("leanlaw").controller("MattersModalController", ["$scope", "details", "close", function ($scope, details, close) {
  $scope.details = details;
  $scope.confirm = () => {
    // TODO Save changes here and return matter in promise
    close(true);
  };
  $scope.reject = () => {
    close(false);
  };
  // Close button action can be assigned to a specific response
  $scope.handleCloseButton = () => {
    close(false);
  };
}]);